import { useMutation, useQueryClient } from "@tanstack/react-query";
import { invalidateSocialGraph } from "Api/Mutations/Social/invalidateSocialGraph";
import { deleteSocialFollowsTargetIdentityUserPublicID } from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";
import { Resources, useResource } from "Translations/Resources";
import { toast } from "sonner";

/** Unfollows a persona (idempotent). */
export const useUnfollowUserMutation = () => {
  const queryClient = useQueryClient();
  const { t } = useResource();

  return useMutation({
    mutationFn: processResponseWithApiProblemDetails(
      (targetIdentityUserPublicID: string) =>
        deleteSocialFollowsTargetIdentityUserPublicID(
          targetIdentityUserPublicID,
        ),
    ),
    onSuccess: () => invalidateSocialGraph(queryClient),
    onError: () => toast.error(t(Resources.Errors.RequestError)),
  });
};
